
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App.tsx";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./context/AuthProvider.tsx";
import { Bounce, ToastContainer } from "react-toastify";
import { MeetingProvider } from "./context/MeetingContext.tsx";
import DisableComponent from "./components/security/DisableComponent.tsx";
import SecureLocationRequest from "./components/security/SecureLocationRequest.tsx";
import { Toaster } from "react-hot-toast";
import { SWRProvider } from "./context/SwrProvider.tsx";
import debug from "debug"; 

if (import.meta.env.VITE_APP_ENV === "development") {
  debug.enable(import.meta.env.VITE_DEBUG || "app:*");
}

createRoot(document.getElementById("root")!).render(
  // <StrictMode>
  <SWRProvider>
    <BrowserRouter>
      <AuthProvider>
        {/* <SocketProvider> */}
        <MeetingProvider>
          <App />
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="light"
            transition={Bounce}
            style={{ zIndex: 1000000 }}
          />
          <Toaster
            position="top-right"
            reverseOrder={false}
            gutter={8}
            containerClassName=""
            containerStyle={{}}
            toasterId="default"
            toastOptions={{
              // Define default options
              className: "",
              duration: 5000,
              removeDelay: 1000,
              style: {
                zIndex: 1000000,
              },

              // Default options for specific types
              success: {
                duration: 3000,
                iconTheme: {
                  primary: "green",
                  secondary: "black",
                },
              },
              error: {
                duration: 3000,
                iconTheme: {
                  primary: "red",
                  secondary: "white",
                },
              },
              loading: {
                duration: 3000,
                iconTheme: {
                  primary: "blue",
                  secondary: "white",
                },
              },
            }}
          />
          <DisableComponent />
          <SecureLocationRequest />
        </MeetingProvider>
        {/* </SocketProvider> */}
      </AuthProvider>
    </BrowserRouter>
  </SWRProvider>,
  // </StrictMode>
);
